import React from 'react';

import Card from 'react-bootstrap/Card';

export function Description(props) {
	const focus = props.focus;

	if ("edge" in focus) {
		return <EdgeDescription focus={focus} />;
	}

	else if ("node" in focus) {
		return <NodeDescription focus={focus} />
	}
}

export function Instructions(props) {
	return (
		<div className="instructions">
			<p>To describe something that is confusing and seems like gibberish, English speakers often use the idiom <b>"It looks/sounds like Greek to me."</b> The implication is that Greek is an obscure, indecipherable language. Hearing this, one might naturally think that this cannot possibly be an idiom in Greek! </p>
			<p>In fact, there is an analogous saying in Greek: <b>"Αυτά μου φαίνονται κινέζικα,"</b> or "This strikes me as Chinese." To Greek speakers, Chinese is stereotypically an obscure and indecipherable language! Many languages have idioms in this vein. They're represented here in the graph to the left.</p>
			<p>An arrow from language A to language B means that there is an idiom in language A which indicates that language B is gibberish. Where possible, I've documented the history and sentences that characterize each of the relations in the graph. Clicking on a link or node will replace this column with data about that language or relation.</p>
			<p className="lead">Enjoy!</p>
		</div>
	);
}

function EdgeDescription(props) {
	const focus = props.focus;

	const nodes = require('./nodes.json');
	const edges = require('./edges.json');

	const edge = edges.find( (edge) => (edge.source === focus.source) && (edge.target === focus.target) );
	const source = nodes.find( (node) => (node.id === edge.source) );
	const target = nodes.find( (node) => (node.id === edge.target) );

	const desc = edge.description;
	var description = [];
	if (desc) {
		if (desc.blurb) { 
			description.push(<Card.Text key={'blurb-'+source.id+'-'+source.target}>{desc.blurb}</Card.Text>); 
		}

		if (desc.history) {
			description.push(<h4 key={'history-'+source.id+'-'+source.target}>History</h4>);
			description.push(<Card.Text key={'history-content-'+source.id+'-'+source.target}>{desc.history}</Card.Text>);
		}

		if (desc.sentences) {
			description.push(<h4 key={'quote-'+source.id+'-'+source.target}>Quotes</h4>);
			for (var i = 0; i < desc.sentences.length; i++) {
				const sentence = desc.sentences[i];
				description.push(
					<div className="mb-2 quote" key={'quote-'+i+'-'+source.id+'-'+source.target}>
						<p className="mb-0">{ sentence.original }</p>
						{ sentence.translations.map((translation) => <p className="mb-0" key={translation}>{ translation }</p> ) }
						{ sentence.attribution && <footer className="blockquote-footer">{ sentence.attribution }</footer> }
					</div>
				)

			}
		}
	}

	let tagline;
	if ("colorFocus" in props) {
		// make a particular language green
		const sourceColor = (source.id === props.colorFocus.id) ? 'text-success' : 'text-secondary';
		const targetColor = (target.id === props.colorFocus.id) ? 'text-success' : 'text-secondary';

		tagline = <h2><span className={sourceColor}>{ source.label }</span> &rarr; <span className={targetColor}>{ target.label }</span></h2>;
	} else {
		tagline = <h2><span className="text-secondary">{ source.label }</span> &rarr; <span className="text-info">{ target.label }</span></h2>;
	}

	return (
		<div className="edgeDescription" id={ edge.source + "-" + edge.target }>
			{ tagline }
			{ desc && (
				<Card className="language-card">
					<Card.Body>
						{description}
					</Card.Body>
				</Card>
			) }
			{ !desc && <p>No data yet... Email <a href='mailto:contact@parthsarin.com'>contact@parthsarin.com</a> to suggest an addition.</p> }
			
		</div>
	)
}

function NodeDescription(props) {
	const focus = props.focus;

	const nodes = require('./nodes.json');
	const edges = require('./edges.json');

	const node = nodes.find( (node) => node.id === focus.id );
	const adjacentEdges = edges.filter( (edge) => (edge.source === node.id) || (edge.target === node.id) );

	return (
		<div className="nodeDescription" id={ node.id }>
			<h1 className="text-center text-success">{ node.label }</h1>
			{ "description" in node && <p>{ node.description }</p> }
			{ adjacentEdges.map((edge) => {
				if (edge.description) {
					return <EdgeDescription focus={{ source: edge.source, target: edge.target }} colorFocus={ node } key={edge.source + edge.target} />;
				}

				return null;
			  }) }
		</div>
	)
}